import {
  LEADERBOARD_SUBMIT_REPLAY_MS,
  LEADERBOARD_SUBMIT_SECRET,
} from "./constants.js";

/**
 * @param {string} playerId
 * @param {number} runIndex
 * @param {number} score
 * @param {number} ts
 * @returns {string}
 */
export function buildLeaderboardSubmitCanonical(playerId, runIndex, score, ts) {
  return String(playerId) + "|" + String(runIndex) + "|" + String(score) + "|" + String(ts);
}

/**
 * @param {number} ts
 * @param {number} [nowMs]
 * @param {number} [replayMs]
 * @returns {boolean}
 */
export function isLeaderboardSubmitTimestampValid(
  ts,
  nowMs,
  replayMs
) {
  var timestamp = Math.floor(Number(ts) || 0);
  var now = nowMs != null ? Math.floor(Number(nowMs) || 0) : Date.now();
  var windowMs = replayMs != null ? Math.max(0, Math.floor(Number(replayMs) || 0)) : LEADERBOARD_SUBMIT_REPLAY_MS;
  if (!isFinite(timestamp) || timestamp <= 0) return false;
  return Math.abs(now - timestamp) <= windowMs;
}

/**
 * @param {ArrayBuffer} buffer
 * @returns {string}
 */
function bufferToHex(buffer) {
  return Array.from(new Uint8Array(buffer), function (byte) {
    return byte.toString(16).padStart(2, "0");
  }).join("");
}

/**
 * @param {{ playerId: string, runIndex: number, score: number, ts: number }} fields
 * @param {string} [secret]
 * @returns {Promise<string>}
 */
export async function signLeaderboardSubmit(fields, secret) {
  var keyMaterial = secret || LEADERBOARD_SUBMIT_SECRET;
  var canonical = buildLeaderboardSubmitCanonical(
    fields.playerId,
    fields.runIndex,
    fields.score,
    fields.ts
  );
  if (typeof crypto === "undefined" || !crypto.subtle) {
    throw new Error("Web Crypto unavailable");
  }
  var cryptoKey = await crypto.subtle.importKey(
    "raw",
    new TextEncoder().encode(keyMaterial),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  var signature = await crypto.subtle.sign(
    "HMAC",
    cryptoKey,
    new TextEncoder().encode(canonical)
  );
  return bufferToHex(signature);
}
